// ====================================================
// src/components/block/liveStreamManagement/videoEffects/ThumbTile.tsx
//
// Tuile carrée (miniature + libellé en bandeau bas) partagée par les réglages qui se
// présentent comme un choix visuel plutôt qu'un <select> ou une rangée de boutons texte
// — Arrière-plan (une vraie image par tuile) et Effet flou (une démonstration du flou
// lui-même par tuile). Un nouveau réglage de ce genre réutilise directement ceci.
// ====================================================

import React from 'react';

export const ThumbTile: React.FC<{
  active: boolean;
  label: string;
  onClick: () => void;
  children: React.ReactNode;
  /** Accessoire additionnel (ex. bouton ⚙ de calibration, cf. AvatarEffect
   * DecorationSection) posé en haut à droite — rendu comme enfant DIRECT de la
   * tuile (déjà `position: relative`), jamais via un <div> englobant en plus :
   * un tel wrapper sort la tuile de la grille CSS qui la rend carrée (elle ne
   * stretch plus sur la largeur de colonne), ce qui donnait des tuiles "Décoration"
   * de tailles n'importe quoi une fois l'icône ⚙ ajoutée (constaté). La tuile est
   * un <div role="button"> (pas un <button>) précisément pour que `corner` puisse
   * être un <button> réel — un <button> ne peut pas en contenir un autre (HTML
   * invalide, le navigateur le réordonne dans le DOM). */
  corner?: React.ReactNode;
}> = ({ active, label, onClick, children, corner }) => (
  <div
    role="button"
    tabIndex={0}
    onClick={onClick}
    onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(); } }}
    title={label}
    style={{
      position: 'relative', aspectRatio: '1', borderRadius: 8, overflow: 'hidden',
      border: `2px solid ${active ? '#34d399' : '#334155'}`, padding: 0, cursor: 'pointer',
      background: '#0f172a',
    }}
  >
    {children}
    <span style={{
      position: 'absolute', bottom: 0, left: 0, right: 0, padding: '2px 4px',
      fontSize: 8, fontWeight: 600, color: '#fff', background: 'rgba(0,0,0,0.55)',
      textAlign: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
    }}>
      {label}
    </span>
    {corner}
  </div>
);
